<template>
    <div class="investor-wrap">
       <el-table :data="investorData" stripe border>
            <el-table-column label="投资人名称"  prop="investor_name"></el-table-column>
            <el-table-column label="投资资金"  prop="investor_amount"></el-table-column>
            <el-table-column label="投资人联系方式"  prop="investor_mobile"></el-table-column>
            <el-table-column label="备注"  prop="investor_content"></el-table-column>
            <el-table-column label="投资时间"  prop="investor_time"></el-table-column>
       </el-table>
    </div>
</template>

<script>
import investorApi from '../../../api/investor';
export default {
    data(){
        return{
            investorData:[]
        }
    },
    created(){
        this.getUserList()
    },
    methods:{
        getUserList(){
            investorApi.investorList({}, true).then(res=>{
                this.investorData = res.data.list
            })
        },
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/investor/investor/list.vue